import DefaultCRUD from '../utils'

const resource = `/content-type`;

const { get } = DefaultCRUD(resource)

export default {
  get,
}
